function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

document.addEventListener("click", (event) => {
  const accordionIcon = event.target.closest(".product-popup-modal__opener .accordion-icon.plus-icon");

  if (!accordionIcon) return;

  const modalSelector = accordionIcon.getAttribute("data-modal");
  if (!modalSelector) return;

  const modal = document.querySelector(modalSelector);
  if (modal && typeof modal.show === "function") {
    modal.show(accordionIcon);
  }
});

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}
// --- Auto-load DeferredMedia when in viewport ---
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".product-detail-images__image-barone deferred-media");

  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const media = entry.target;

          // Trigger loadContent() once
          if (media && typeof media.loadContent === "function" && !media.hasAttribute("loaded")) {
            media.loadContent(false); // false => don't focus
          }
        }
      });
    },
    {
      threshold: 0.3, // adjust — element must be 30% visible
    }
  );

  targets.forEach((media) => observer.observe(media));
});


customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  connectedCallback() {
    // Call filterImgVariant when the element is added to the DOM
    this.filterImgVariant();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.filterImgVariant();
    var breezeButton = document.getElementsByClassName('product-form_breezeButton')[0];
    var variant = this.currentVariant;
      try {
            let variant1 = variant;
            if (!variant1?.available){
              breezeButton.setAttribute("enable","false");
            }
            else{
              breezeButton.setAttribute("enable","true");
            }
          } catch (e) {}  



    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  filterImgVariant() {
    if (this.currentVariant && this.currentVariant.featured_media) {
      document.querySelectorAll('[thumbnail-alt]').forEach(img => {
        img.style.display = 'none';  // Hide all images initially
      });
  
      const currentImgAlt = this.currentVariant.featured_media.alt || this.currentVariant.featured_media.id;
  
      if (currentImgAlt) {
        const thumbnailSelector = `[thumbnail-alt='${currentImgAlt}']`;
        document.querySelectorAll(thumbnailSelector).forEach(img => {
          img.style.display = 'block';  // Show matching images
        });
        const visibleImages = document.querySelectorAll(thumbnailSelector);
        if (visibleImages.length > 0) {
            visibleImages[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    } else {
        document.querySelectorAll('[default-image]').forEach(img => {
          img.style.display = 'none';
      });
    }
  }
  // filterImgVariant() {
  //   const currentAlt = this.currentVariant?.featured_media?.alt?.toLowerCase();
  //   if (!currentAlt) return;

  //   document.querySelectorAll('[thumbnail-alt]').forEach(el => {
  //     el.hidden = el.getAttribute("thumbnail-alt").toLowerCase() !== currentAlt;
  //   });
  // }


  
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, fieldset"),
      (element) => {
        if (element.tagName === "SELECT") {
          return element.value;
        }
        if (element.tagName === "FIELDSET") {
          return Array.from(element.querySelectorAll("input")).find(
            (radio) => radio.checked
          )?.value;
        }
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      // const selectedSwatchValue = this.querySelector(
      //   `[data-selected-swatch-value="${name}"]`
      // );
      // if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      const selectedValueEl =
      this.querySelector(`[data-selected-swatch-value="${name}"]`) ||
      document.getElementById(`selected-${name}`);
      if (selectedValueEl) {
        selectedValueEl.textContent = value;
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value
            );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const mediaGallerySource = document.querySelector(
      `[id^="MediaGallery-${this.dataset.section}"] ul`
    );
    const mediaGalleryDestination = html.querySelector(
      `[id^="MediaGallery-${this.dataset.section}"] ul`
    );

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(
        mediaGallerySource.querySelectorAll("li[data-media-id]")
      );
      const sourceSet = new Set(
        mediaGallerySourceItems.map((item) => item.dataset.mediaId)
      );
      const sourceMap = new Map(
        mediaGallerySourceItems.map((item, index) => [
          item.dataset.mediaId,
          { item, index },
        ])
      );
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(
        mediaGalleryDestination.querySelectorAll("li[data-media-id]")
      );
      const destinationSet = new Set(
        mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
      );
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh)
        [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach(
        (destinationItem, destinationIndex) => {
          const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

          if (sourceData && sourceData.index !== destinationIndex) {
            mediaGallerySource.insertBefore(
              sourceData.item,
              mediaGallerySource.querySelector(
                `li:nth-of-type(${destinationIndex + 1})`
              )
            );

            // refresh source now that it has been modified
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();
          }
        }
      );
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`
        );
    }

    // update media modal
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent)
      modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this)
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);





document.addEventListener('DOMContentLoaded', function() {
  var catalogLogoIcon = document.querySelector('.header__heading-link');
  var menuDrawer = document.querySelector('.menu-drawer');
  var menuDrawerLogo = document.querySelector('.header__heading');
   
    
  function toggleLogoVisibility() {
      var menuOpening = document.querySelector('.menu-opening');
      var homePage = document.body.classList.contains('template_index');
    
      if (menuOpening && catalogLogoIcon && homePage) {
          if (menuDrawer.classList.contains('menu-drawer-animation')) {
              menuDrawer.classList.remove('menu-drawer-animation');
          }
          if (menuDrawerLogo.classList.contains('header__heading-animation')) {
              menuDrawerLogo.classList.remove('header__heading-animation');
          }
          if (catalogLogoIcon.classList.contains('header__heading-link_medium')) {
              catalogLogoIcon.classList.remove('header__heading-link_medium');
          }
      } else if (!menuOpening) {
          menuDrawer.style.transition = '';
      } else if (menuOpening && catalogLogoIcon) {
          menuDrawer.style.transition = 'none';
          if (catalogLogoIcon.classList.contains('header__heading-link_medium')) {
              catalogLogoIcon.classList.remove('header__heading-link_medium');
          }
      } else if (!menuOpening) {
          catalogLogoIcon.style.display = '';
          menuDrawer.style.transition = 'none';

          observer.disconnect();
      }
  }

  var observer = new MutationObserver(toggleLogoVisibility);

  var mediaQuery = window.matchMedia("(min-width: 750px)");

  function handleMediaQueryChange(e) {
      if (e.matches) {
          observer.observe(document.body, { attributes: true, childList: true, subtree: true });
          toggleLogoVisibility();
      } else {
          observer.disconnect();
          if (catalogLogoIcon) {
              catalogLogoIcon.style.width = '';
              catalogLogoIcon.style.maxWidth = '';
          }
      }
  }

  mediaQuery.addEventListener('change', handleMediaQueryChange);

  handleMediaQueryChange(mediaQuery);
});



document.addEventListener('DOMContentLoaded', function() {
    var header = document.querySelector('.header-wrapper');
    
    function toggleLogoVisibility() {
        var menuOpening = document.querySelector('.menu-opening');
        
        if (menuOpening && header) {
            header.style.background = '#fff';
        } else if (header) {
            header.style.background = '';
        }
    }

    var observer = new MutationObserver(toggleLogoVisibility);

    var mediaQuery = window.matchMedia("(max-width: 749px)");

    function handleMediaQueryChange(e) {
        if (e.matches) {
            observer.observe(document.body, { attributes: true, childList: true, subtree: true });
            toggleLogoVisibility();
        } else {
            observer.disconnect();
            if (header) {
                header.style.background = '';
            }
        }
    }

    mediaQuery.addEventListener('change', handleMediaQueryChange);

    handleMediaQueryChange(mediaQuery);
});







document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains('template_index')) return;
  
  const slider = document.querySelector('.slider-mobile-gutter ul');
  const slides = document.querySelectorAll('.slider-mobile-gutter li');

  if (!slider || slides.length === 0) {
    return;
  }
  
  window.index = 0;
  // let index = 0;
  let autoScroll = true;
  let autoScrollInterval;
  let manualScrollTimeout;

  const slideInterval = 5000;
  const lastSlideInterval = 5000;
  const scrollPauseDuration = 5000;

  function getIndexFromScrollPosition() {
    const currentScroll = slider.scrollTop;
    const slideHeight = slider.querySelector('li').offsetHeight || window.innerHeight;
    return Math.round(currentScroll / slideHeight);
  }

  function isLastSlide() {
    const currentScroll = slider.scrollTop;
    const slideHeight = slider.querySelector('li').offsetHeight || window.innerHeight;
    const maxScroll = slider.scrollHeight - slideHeight;

    // if (window.innerWidth <= 749) {
    //   console.log('Small screen detected');
    // }

    return currentScroll >= maxScroll - 1;
  }

  function slide() {
    if (!autoScroll || slides.length === 0) return;

    if (isLastSlide()) {
      autoScrollInterval = setTimeout(() => {
        index = 0;
        slider.scrollTo({
          top: 0,
          behavior: 'auto'
        });

        setTimeout(() => {
          if (autoScroll) {
            slider.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        }, scrollPauseDuration);

        startAutoScroll();
      }, lastSlideInterval);

    } else {
      index++;
      const slideHeight = slider.querySelector('li').offsetHeight || window.innerHeight;
      slider.scrollTo({
        top: index * slideHeight,
        behavior: 'smooth'
      });

      autoScrollInterval = setTimeout(slide, slideInterval);
    }

    // console.log(index);
  }

  window.startAutoScroll = () => {
    autoScroll = true;
    autoScrollInterval = setTimeout(slide, slideInterval);
  }

  function stopAutoScroll() {
    autoScroll = false;
    clearTimeout(autoScrollInterval);
  }

  function handleScroll() {
    stopAutoScroll();
    clearTimeout(manualScrollTimeout);
    index = getIndexFromScrollPosition();
    manualScrollTimeout = setTimeout(startAutoScroll, scrollPauseDuration);
  }

  function handleMousedown() {
    stopAutoScroll();
    clearTimeout(manualScrollTimeout);
    index = getIndexFromScrollPosition();
    // console.log("stopped", index);
  }

  function handleMouseUp() {
    manualScrollTimeout = setTimeout(startAutoScroll, scrollPauseDuration);
  }

  function initSlider() {
    index = 0;

    const start = () => {
      startAutoScroll();
      slider.addEventListener('scroll', handleScroll);
      document.addEventListener("mousedown", handleMousedown);
      document.addEventListener("mouseup", handleMouseUp);
    };

    if (window.innerWidth <= 436) {
      setTimeout(start, 3500);
    } else {
      start();
    }
  }
  
  initSlider();
});


// function initAudioContext() {
//     if (typeof audioCtx === 'undefined') {
//         window.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
//         console.log('AudioContext created');
//     } else if (audioCtx.state === 'suspended') {
//         audioCtx.resume().then(() => {
//             console.log('AudioContext resumed');
//         });
//     }
// }

// document.addEventListener('click', initAudioContext);
// document.addEventListener('touchstart', initAudioContext);
// document.addEventListener('keydown', initAudioContext);

// document.addEventListener('click', function removeListener() {
//     initAudioContext();
//     document.removeEventListener('click', initAudioContext);
//     document.removeEventListener('touchstart', initAudioContext);
//     document.removeEventListener('keydown', initAudioContext);
//     document.removeEventListener('click', removeListener);
// });

document.addEventListener("DOMContentLoaded", function() {
  const statusElement = document.querySelector('.predictive-search-status');
  const productList = document.getElementById('predictive-search-results-products-list');
  
  if (statusElement && productList) {
    if (statusElement.textContent.includes('suggestions')) {
      productList.classList.add('has-suggestions');
    } else {
      productList.classList.remove('has-suggestions');
    }
  }
});


document.addEventListener("DOMContentLoaded", () => {
    const secondClass = document.querySelector(".second_class");

  if (window.innerWidth > 750) {
    if (secondClass) {
        const observer = new MutationObserver(() => {
            const socialLogins = document.querySelector(".frcp-social-logins.frcp-social-logins--below");
            if (socialLogins && !secondClass.contains(socialLogins)) {
                secondClass.appendChild(socialLogins); // Move socialLogins into secondClass
            }
        });

        // Observe changes to the entire body
        observer.observe(document.body, {
            childList: true, // Watch for direct child changes
            subtree: true,  // Watch for all descendants
        });
    }
  }
});





const VW = document.querySelectorAll(".slider-mobile-gutter li");

VW.forEach(W => {
  const videoMobile = W.querySelector("video.mobile");
  const buttonMobile = W.querySelector("button.home_mobile_img");
  const videoDesktop = W.querySelector("video.desktop");
  const buttonDesktop = W.querySelector("button.home_desktop_img");

  const toggleMute = (video, button) => {
    if (!video || !button) return;

    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const btn = e.target.closest("button");
      btn?.blur();

      if (video.muted) {
        video.muted = false;
        video.removeAttribute("muted");
        btn?.classList.add("unmutedbtn");
        btn?.classList.remove("mutedbtn");
      } else {
        video.muted = true;
        video.setAttribute("muted", "true");
        btn?.classList.add("mutedbtn");
        btn?.classList.remove("unmutedbtn");
      }
    });
  };

  toggleMute(videoMobile, buttonMobile);
  toggleMute(videoDesktop, buttonDesktop);
});


document.addEventListener('gesturestart', function(e) {
    e.preventDefault();
    document.body.style.zoom = 1;
});
document.addEventListener('gesturechange', function(e) {
    e.preventDefault();
    document.body.style.zoom = 1;
});
document.addEventListener('gestureend', function(e) {
    e.preventDefault();
    document.body.style.zoom = 1;
});






// function attachListeners() {
//   const productLinks = document.querySelectorAll(".media--slider-effect > a");

//   productLinks.forEach((link) => {
//     let imagesAppended = false;

//     const firstImg = link.querySelector("img");
//     if (!firstImg) return;

//     const targetAlt = firstImg.alt;

//     function appendImages() {
//       if (imagesAppended) return;
//       imagesAppended = true;

//       const imagesData = link.getAttribute("data-images");
//       if (!imagesData) return;

//       try {
//         const parsedImages = JSON.parse(imagesData.replace(/&quot;/g, '"'));

//         parsedImages.forEach((imageData) => {
//           if (imageData.alt === targetAlt) {
//             const newImg = document.createElement("img");
//             const baseSrc = imageData.src.split("?")[0];
//             const srcsetSizes = [165, 360, 533, 720, 940, 1066];
//             const srcset = srcsetSizes
//               .map((size) => `${baseSrc}?width=${size} ${size}w`)
//               .join(", ");
//             newImg.srcset = srcset;
//             newImg.src = imageData.src;
//             newImg.sizes = `(min-width: 1600px) 367px,(min-width: 990px) calc((100vw - 130px) / 4),(min-width: 750px) calc((100vw - 120px) / 3),calc((100vw - 35px) / 2)`.trim();
//             newImg.alt = imageData.alt;
//             newImg.className = "motion-reduce";
//             newImg.loading = "lazy";
//             newImg.width = 533;
//             link.appendChild(newImg);
//           }
//         });
//       } catch (error) {
//         console.error("Error parsing images JSON:", error);
//       }
//     }

//     let startX = 0;
//     link.addEventListener("touchstart", (e) => {
//       startX = e.touches[0].clientX;
//     });

//     link.addEventListener("touchmove", (e) => {
//       let diffX = e.touches[0].clientX - startX;
//       if (diffX < -50) appendImages();
//     });

//     link.addEventListener("mouseenter", appendImages);
//   });
// };


function attachListeners() {
  const productLinks = document.querySelectorAll(".media--slider-effect > a");

  productLinks.forEach((link) => {
    // If this link was already initialized, skip it.
    if (link.dataset.imagesInitialized === "true" || link.classList.contains("images-initialized")) {
      return;
    }

    // Mark as initialized immediately so repeated calls won't re-bind/append.
    link.dataset.imagesInitialized = "true";
    link.classList.add("images-initialized");

    // Per-link state that persists on this DOM node (no global state required)
    let imagesAppended = false;

    const firstImg = link.querySelector("img");
    if (!firstImg) return;

    const targetAlt = firstImg.alt;

    function appendImages() {
      if (imagesAppended) return;
      imagesAppended = true;

      const imagesData = link.getAttribute("data-images");
      if (!imagesData) return;

      try {
        // data-images might be escaped; normalize it
        const json = imagesData.replace(/&quot;/g, '"');
        const parsedImages = JSON.parse(json);

        parsedImages.forEach((imageData) => {
          // Only append images that match the thumb's alt
          if (imageData.alt === targetAlt) {
            // Prevent adding duplicate by checking for existing src
            const already = Array.from(link.querySelectorAll("img")).some(img => {
              // compare file path ignoring width query params
              const imgSrcBase = imageData.src.split("?")[0];
              return img.src && img.src.split("?")[0] === imgSrcBase;
            });
            if (already) return;

            const newImg = document.createElement("img");
            const baseSrc = imageData.src.split("?")[0];
            const srcsetSizes = [165, 360, 533, 720, 940, 1066];
            const srcset = srcsetSizes
              .map((size) => `${baseSrc}?width=${size} ${size}w`)
              .join(", ");
            newImg.srcset = srcset;
            newImg.src = imageData.src;
            newImg.sizes = `(min-width: 1600px) 367px,(min-width: 990px) calc((100vw - 130px) / 4),(min-width: 750px) calc((100vw - 120px) / 3),calc((100vw - 35px) / 2)`.trim();
            newImg.alt = imageData.alt;
            newImg.className = "motion-reduce";
            newImg.loading = "lazy";
            newImg.width = 533;
            link.appendChild(newImg);
          }
        });
      } catch (error) {
        console.error("Error parsing images JSON:", error);
      }
    }

    let startX = 0;
    link.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    link.addEventListener("touchmove", (e) => {
      let diffX = e.touches[0].clientX - startX;
      if (diffX < -5) appendImages();
    }, { passive: true });

    link.addEventListener("mouseenter", appendImages);

    link.addEventListener("pointerdown", (e) => {
      appendImages();
    }, { passive: true });
  });
}



// Debounced and fail-safe wishlist icon updater
function updateWishlistIcons() {
  // Ensure FRCP and wishlist module exist
  if (!window.frcp || !frcp.wishlist || typeof frcp.wishlist.attachOnCollection !== "function") {
    console.warn("FRCP Wishlist not ready yet, retrying...");
    // Retry once after a short delay (for lazy-loaded scripts)
    setTimeout(updateWishlistIcons, 300);
    return;
  }

  // Debounce repeated calls (scroll spam / fast AJAX)
  if (updateWishlistIcons._timeout) clearTimeout(updateWishlistIcons._timeout);
  updateWishlistIcons._timeout = setTimeout(() => {
    try {
      // Safe attach wrapped in try block
      frcp.wishlist.attachOnCollection();

      // Use a static NodeList snapshot (prevents live reflow)
      const icons = Array.from(document.querySelectorAll(".frcp-wishlist__icon"));

      // Cache the path string to avoid parsing overhead
      const filledHeartPath =
        "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z";

      for (const icon of icons) {
        try {
          // Skip if icon already replaced
          if (icon.dataset.replaced === "true") continue;

          // Detect the filled-heart SVG via string match (safer than DOM compare)
          const html = icon.innerHTML;
          if (html && html.includes(filledHeartPath)) {
            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("class", "frcp-wishlist__icon");
            svg.setAttribute("preserveAspectRatio", "xMidYMid slice");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");
            svg.setAttribute("viewBox", "0 0 24 24");
            svg.setAttribute("fill", "inherit");
            svg.setAttribute("stroke", "inherit");

            const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path.setAttribute("fill-rule", "evenodd");
            path.setAttribute("clip-rule", "evenodd");
            path.setAttribute(
              "d",
              "M12 15.238L17 20V4H7v16l5-4.762zm-4 2.429l4-3.81 4 3.81V5H8v12.667z"
            );
            svg.appendChild(path);

            icon.replaceWith(svg);
            svg.dataset.replaced = "true";
          }
        } catch (innerErr) {
          console.debug("Wishlist icon update skipped:", innerErr);
        }
      }
    } catch (err) {
      console.error("Wishlist update failed:", err);
    }
  }, 120); // debounce delay
}



// function autocompletelistener() {
//   const input = document.querySelector('.search__input.field__input');
//   const resultsList = document.querySelector('#search-autocomplete-results');
//   const productgrid = document.querySelector('.template-search .product-grid-container');
//   const facets = document.querySelector('.template-search .facets-wrapper');
//   const resetButton = document.querySelector('.reset__button');
//   const facetsContainer = document.querySelector('.template-search .facets-container');
//   let debounceTimer;

//   if (!input || !resultsList) return;

//   // Hide initially
//   resultsList.style.display = 'none';

//   input.addEventListener('input', () => {
//     const query = input.value.trim().toLowerCase();
//     clearTimeout(debounceTimer);
//     resultsList.innerHTML = '';
//     // resultsList.style.display = 'none';

//     if (!query || query.length < 2) {
//       if (window.innerWidth <= 749) {
//         if (facets) facets.style.top = '';
//         if (productgrid) productgrid.style.marginTop = '';
//       }
//       return;
//     }

//     debounceTimer = setTimeout(() => {
//       fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
//         .then((res) => res.json())
//         .then((data) => {
//           const productResults = data.resources.results.products || [];
//           const allSuggestions = [];

//           productResults.forEach((product) => {
//             const title = product.title.toLowerCase();
//             if (title.includes(query)) allSuggestions.push(title);

//             (product.tags || []).forEach((tag) => {
//               const tagLower = tag.toLowerCase();
//               if (tagLower.includes(query)) allSuggestions.push(tagLower);
//             });
//           });

//           const uniqueSuggestions = [...new Set(allSuggestions)].slice(0, 10);

//           if (uniqueSuggestions.length > 0) {
//             resultsList.style.display = 'flex';

//             if (window.innerWidth <= 749) {
//               if (facets) facets.style.top = '179px';
//               if (productgrid) productgrid.style.marginTop = '128px';
//             }

//             uniqueSuggestions.forEach((suggestion, index) => {
//               const matchIndex = suggestion.indexOf(query);
//               const before = suggestion.slice(0, matchIndex);
//               const match = suggestion.slice(matchIndex, matchIndex + query.length);
//               const after = suggestion.slice(matchIndex + query.length);
//               const afterWords = after.split(' ').filter(Boolean);

//               const li = document.createElement('li');
//               li.setAttribute('role', 'option');
//               li.setAttribute('aria-selected', 'false');
//               li.className = 'search-products-form__autocomplete-term';
//               li.id = `search-products-form-combo-item-${index}`;

//               const spanBefore = before ? `<span class="search-products__autocomplete-part">${before}</span>` : '';
//               const spanMatch = `<span class="search-products__autocomplete-part search-products__autocomplete-part--match">${match}</span>`;
//               // const spanAfter = afterWords.map(word => `<span class="search-products__autocomplete-part"> ${word}</span>`).join('');
//               const spanAfter = afterWords.map(word => `<span class="search-products__autocomplete-part">${word}</span>`).join(' ');


//               li.innerHTML = spanBefore + spanMatch + spanAfter;
//               resultsList.appendChild(li);
//             });
//           } else {
//             resultsList.style.display = 'none';
//           }
//         })
//         .catch(err => {
//           console.error('Autocomplete fetch error:', err);
//           resultsList.style.display = 'none';
//         });
//     }, 300);
//   });

//   resultsList.addEventListener('click', (e) => {
//     if (e.target.closest('li')) {
//       const selectedText = e.target.closest('li').innerText.trim();
//       input.value = selectedText;
//       input.form.submit();
//     }
//   });

//   resetButton?.addEventListener('click', () => {
//     resultsList.innerHTML = '';
//     resultsList.style.display = 'none';

//     if (window.innerWidth <= 749) {
//       if (facetsContainer) facetsContainer.style.top = '';
//       if (productgrid) productgrid.style.marginTop = '';
//     }
//   });

//   window.addEventListener('scroll', () => {
//     resultsList.innerHTML = '';
//     resultsList.style.display = 'none';

//     if (window.innerWidth <= 749) {
//       if (facets) facets.style.top = '';
//       if (productgrid) productgrid.style.marginTop = '';
//     }
//   });
// }

function autocompletelistener() {
  const input = document.querySelector('.search__input.field__input');
  const resultsList = document.querySelector('#search-autocomplete-results');
  const productgrid = document.querySelector('.template-search .product-grid-container');
  const facets = document.querySelector('.template-search .facets-wrapper');
  const resetButton = document.querySelector('.reset__button');
  const facetsContainer = document.querySelector('.template-search .facets-container');
  let debounceTimer;

  if (!input || !resultsList) return;

  // Hide initially
  resultsList.style.display = 'none';

  input.addEventListener('input', () => {
    const query = input.value.trim().toLowerCase();
    clearTimeout(debounceTimer);
    // resultsList.innerHTML = '';
    resultsList.classList.add('updating');
    // resultsList.style.display = 'none';

    if (!query || query.length < 2) {
      if (window.innerWidth <= 749) {
        if (facets) facets.style.top = '';
        if (productgrid) productgrid.style.marginTop = '';
      }
      if (window.innerWidth >= 750) {
        if (facets) facets.style.marginTop = '';
      }
      return;
    }

    debounceTimer = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
        .then((res) => res.json())
        .then((data) => {
          const productResults = data.resources.results.products || [];
          const allSuggestions = [];

          productResults.forEach((product) => {
            const title = product.title.toLowerCase();
            if (title.includes(query)) allSuggestions.push(title);

            (product.tags || []).forEach((tag) => {
              const tagLower = tag.toLowerCase();
              if (tagLower.includes(query)) allSuggestions.push(tagLower);
            });
          });

          const uniqueSuggestions = [...new Set(allSuggestions)].slice(0, 10);

          if (uniqueSuggestions.length > 0) {
            resultsList.style.display = 'flex';

            if (window.innerWidth <= 749) {
              if (facets) facets.style.top = '179px';
              if (productgrid) productgrid.style.marginTop = '128px';
            }
            if (window.innerWidth >= 750) {
              if (facets) facets.style.marginTop = '32px';
            }
            const fragment = document.createDocumentFragment();

            uniqueSuggestions.forEach((suggestion, index) => {
              const matchIndex = suggestion.indexOf(query);
              const before = suggestion.slice(0, matchIndex);
              const match = suggestion.slice(matchIndex, matchIndex + query.length);
              const after = suggestion.slice(matchIndex + query.length);
              // const afterWords = after.split(' ').filter(Boolean);
            
              const li = document.createElement('li');
              li.setAttribute('role', 'option');
              li.setAttribute('aria-selected', 'false');
              li.className = 'search-products-form__autocomplete-term';
              li.id = `search-products-form-combo-item-${index}`;
            
              const spanBefore = before ? `<span class="search-products__autocomplete-part">${before}</span>` : '';
              const spanMatch = `<span class="search-products__autocomplete-part search-products__autocomplete-part--match">${match}</span>`;
              const spanAfter = `<span class="search-products__autocomplete-part">${after}</span>`;
            
              li.innerHTML = spanBefore + spanMatch + spanAfter;
              fragment.appendChild(li);
            });
            
            // Only update results once
            resultsList.innerHTML = '';
            resultsList.appendChild(fragment);
            resultsList.style.display = 'flex';
            resultsList.classList.remove('updating');

          } else {
            resultsList.style.display = 'none';
          }
        })
        .catch(err => {
          console.error('Autocomplete fetch error:', err);
          resultsList.style.display = 'none';
        });
    }, 300);
  });

  resultsList.addEventListener('click', (e) => {
    if (e.target.closest('li')) {
      const selectedText = e.target.closest('li').innerText.trim();
      input.value = selectedText;
      input.form.submit();
    }
  });

  resetButton?.addEventListener('click', () => {
    resultsList.innerHTML = '';
    resultsList.style.display = 'none';

    if (window.innerWidth <= 749) {
      if (facetsContainer) facetsContainer.style.top = '';
      if (productgrid) productgrid.style.marginTop = '';
    }
    if (window.innerWidth >= 750) {
      if (facetsContainer) facetsContainer.style.marginTop = '';
    }
  });

  window.addEventListener('scroll', () => {
    resultsList.innerHTML = '';
    resultsList.style.display = 'none';

    if (window.innerWidth <= 749) {
      if (facets) facets.style.top = '';
      if (productgrid) productgrid.style.marginTop = '';
    }
    if (window.innerWidth >= 750) {
      if (facets) facets.style.marginTop = '';
    }
  });
}

